<template>
  <div class="pwd">
    <el-card class="msg">
      <div class="title">{{ $t("perPwd.securitySettings") }}</div>

      <div class="box">
        <img src="../assets/images/user.png" alt="" />
        <strong>{{ $t("perPwd.loginPassword") }}</strong>
        <span class="shu">| </span>
        <span class="pl">{{ $t("perPwd.pwd") }}</span>
        <div class="fr" @click="updt()">{{ $t("perPwd.modification") }}</div>
      </div>

      <div class="tips">
        <div class="title">
          <strong>{{ $t("perPwd.securityServiceTips") }}</strong>
        </div>
        <div class="text">
          ·
          {{ $t("perPwd.affirm") }}
          <br />
          · {{ $t("perPwd.suggest") }}
        </div>
      </div>
    </el-card>
    <up-pwd ref="upPwd"></up-pwd>
  </div>
</template>
<script>
import Store from "../store";
import upPwd from "./up-pwd.vue";
export default {
  components: { upPwd },
  data() {
    return {
      store: Store.state,
    };
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });


    Store.setPath("4");
  },
  methods: {
    updt() {
      this.$refs.upPwd.up();
    },
  },
};
</script>
<style lang="less" scoped>
.msg {
  // width: 60rem;
  height: 46.875rem;
  .title {
    color: rgb(67, 188, 183);
    line-height: 2.5rem;
    border-bottom: 0.25rem solid rgb(67, 188, 183);
  }
  .box {
    height: 7.5rem;
    border: 0.0313rem solid #ccc;
    margin-top: 1.875rem;
    padding: 3.125rem 1.875rem;
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    img {
      width: 1rem;
      height: 1rem;
    }
    .shu {
      margin: 0 1.875rem;
    }
    .pl {
      color: #ccc;
      flex: 1;
    }
    .fr {
      color: rgb(196, 21, 21);
    }
  }
  .tips {
    // height: 10.3125rem;
    background-color: #f1f1f1;
    margin-top: 15.625rem;
    padding: 1.25rem 1.875rem;
    box-sizing: border-box;
    .title {
      color: #000;
      line-height: 1.875rem;
      border: none;
    }
    .text {
      margin-top: 1.25rem;
      color: #999;
      font-size: 0.9375rem;
      line-height: 1.875rem;
    }
  }
}
</style>
